import { createReducerContext } from '../../../../utils/create-reducer-context';
import { QuestionAnswerSearchState, QuestionAnswerSearchReducer, ACTION_TYPES } from './question-answer-search-reducer';

const initialState: QuestionAnswerSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    categories: [],
    drawer: { open: false },
};

const { Provider: QuestionAnswerSearchProvider, useStateContext: useQuestionAnswerSearchState, useDispatchContext: useQuestionAnswerSearchDispatch } = createReducerContext('QuestionAnswerSearch', QuestionAnswerSearchReducer, initialState);

export { QuestionAnswerSearchProvider, useQuestionAnswerSearchState, useQuestionAnswerSearchDispatch, ACTION_TYPES };
